import React from 'react';

export default function Robot() {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.608 3.748a1.25 1.25 0 0 1 0 1.768l-1.145 1.141 1.17.001a3.75 3.75 0 0 1 3.748 3.754l-.005 7.5a3.75 3.75 0 0 1-3.753 3.747l-12.5-.008a3.75 3.75 0 0 1-3.747-3.753l.005-7.5a3.75 3.75 0 0 1 3.752-3.747H7.3L6.16 5.51a1.25 1.25 0 1 1 1.768-1.767l2.65 2.654q.12.119.198.257l3.214.002q.08-.14.199-.258l2.652-2.65a1.25 1.25 0 0 1 1.768.001m.024 5.42-12.5-.008a1.25 1.25 0 0 0-1.248 1.156l-.003.094-.005 7.5c0 .659.51 1.2 1.156 1.247l.093.004 12.5.008a1.25 1.25 0 0 0 1.248-1.156l.003-.093.005-7.5c0-.69-.56-1.25-1.25-1.25zM8.63 11.662c.69 0 1.25.56 1.25 1.25l-.002 1.25a1.25 1.25 0 1 1-2.5-.001l.001-1.25c0-.69.561-1.25 1.251-1.25m7.5.004c.69.001 1.25.561 1.25 1.251l-.002 1.25a1.25 1.25 0 1 1-2.5-.001l.001-1.25c0-.69.561-1.25 1.251-1.25'
        fill='currentColor'
      />
    </svg>
  );
}
